import React from "react";
import { modelNameFilter } from "../../../../../../../../services/FilteringUtils";
import ModelService from "../../../../../../../../services/ModelService";
import CommonUtil from "../../../../../../../../utils/CommonUtil";
import { constants } from "../../../../../../../../utils/Constants";
import ClassificationModelSelection from "./ClassificationModelSelection";
import SearchableTreeComponent from "../../../../../../page/SearchableTreeComponent/SearchableTreeComponent";

class ClassificationModelSelectionContainer extends SearchableTreeComponent {
  constructor(props) {
    super(props);

    this.modelService = new ModelService();
  }

  initialSortInfo() {
    return {
      orderBy: "name",
      direction: "asc"
    };
  }

  getSearchFilter() {
    return modelNameFilter;
  }

  loadRoots = pageInfo => {
    this.prepareCall(
      this.modelService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onRootDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadData = expanded => {
    this.prepareCall(
      this.modelService.getModelsFromParent(
        expanded,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    return this.performCalls();
  };

  checkNodeCallback = (item, data) => {
    return (
      "" + item.id ===
      CommonUtil.queryParamsGetValueForKey(
        constants.MODEL_PARENT_ID,
        data._links.self.href
      )
    );
  };

  onItemClick = key => {
    const items = this.state.content;
    const childrenItems = this.removeDisabledParentsFromTree(items);
    const item = CommonUtil.findItemInTreeById(childrenItems, parseInt(key));
    this.props.onSelectModel(item);
  };

  removeDisabledParentsFromTree = tree => {
    let children = [];
    if (tree && tree.length > 0) {
      tree.forEach(element => {
        if (!element.disabled) {
          children.push(element);
        }
        if (element.children && element.children.length > 0) {
          children = children.concat(element.children);
        }
      });
    }
    return children;
  };

  loadEntitiesWithFilter = pageInfo => {
    return this.loadRoots(pageInfo);
  };

  createSearchInfo = (searchValue, pageInfo) => {
    pageInfo.filters.modelName.filterVal = searchValue;
    return pageInfo;
  };

  removeModel = event => {
    this.props.removeModel(event.currentTarget.id);
  };

  render() {
    return (
      <ClassificationModelSelection
        {...this.renderProps()}
        onItemClick={this.onItemClick}
        selectedModels={this.props.selectedModels}
        removeModel={this.removeModel}
      />
    );
  }
}

export default ClassificationModelSelectionContainer;
